import React from 'react';
import UmoTools from './umo';
import YoumoTools from './youmo';

const HeaderTools = ({ Site, ...props }) => {
  return Site === 'umo' ? <UmoTools {...props} /> : <YoumoTools {...props} />;
};

export default HeaderTools;
